import { LatLng } from "./simpleTypes";
import { Asset } from "./asset";
import { RichText } from "./richText";
import { IStickyNoteProperties, StickyNoteProperties } from "./stickyNoteProperties";

export class StickyNote extends Asset implements IStickyNoteProperties {
  constructor(id: string, stickyNoteProperties: StickyNoteProperties, geometry: LatLng) {
    super(id);
    this.geometry = geometry;
    this.richTexts = stickyNoteProperties.richTexts;
    this.styles = stickyNoteProperties.styles;
  }

  [key: string]: any;
  geometry: LatLng;
  richTexts: RichText[];
}
